import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { BACKEND_PIVOT } from 'core/constants/endpoints'
import sessionCachePromise from 'core/sessionCachePromise'

function getPriceRange(stateAcronym) {
  return fetchJSONHandleError({
    url: `${BACKEND_PIVOT}/priceRange/${stateAcronym}`
  })
}

export default sessionCachePromise(getPriceRange, 'PRICE_RANGE')
